import * as React from "react";
import { Table, TableContainer, Tbody, Td, Th, Thead, Tr } from "@chakra-ui/react";
import { Page } from "components/page";

var scores = [
    ['Katie', 32.02, '04/29/2024'],
    ['Daniel', 32.84, '05/08/2024'],
    ['Ben', 33.77, '05/08/2024'],
    ['Daniel', 34.11, '04/29/2024'],
    ['Ben', 35.03, '05/07/2024'],
    ['Sam', 39.42, '05/07/2024'],
    ['Katie & Ben Tandem', '1:14.83', '05/09/2024'],
];

const cellProps = { borderColor: "line", px: 0, py: 3 };

const FreeSkateScores = () => {
  return (
    <Page title="Free Skates" intro="100m challenge (backward-turning)">
      <TableContainer>
        <Table variant="simple">
          <Thead>
            <Tr>
              <Th {...cellProps} color="muted">Skater</Th>
              <Th {...cellProps} color="muted" isNumeric>Time (s)</Th>
              <Th {...cellProps} color="muted" isNumeric>Date</Th>
            </Tr>
          </Thead>
          <Tbody>
            {scores.map((score, index) => (
              <Tr key={index}>
                <Td {...cellProps}>{score[0]}</Td>
                <Td {...cellProps} isNumeric fontFamily="mono">{score[1]}</Td>
                <Td {...cellProps} isNumeric fontFamily="mono" color="muted">{score[2]}</Td>
              </Tr>
            ))}
          </Tbody>
        </Table>
      </TableContainer>
    </Page>
  );
}

export default FreeSkateScores;
